import './Features.scss';

import React from 'react';
import Text from 'fe-design-base/atoms/Text';

import { cxHelpers } from 'util/className';

import { FeaturesProps } from './types';
const { cx } = cxHelpers('Features');

export const Features = ({ features }: FeaturesProps) => (
  <ul className={cx()}>
    {features.map(feature => (
      <li key={feature}>
        <Text variant="body" color="mono900">
          {feature}
        </Text>
      </li>
    ))}
  </ul>
);

export default Features;
